import { type FunctionComponent } from 'react';

import { Button, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import BreakoutRoomOptionsContainer from '../BreakoutRoomOptionsContainer';
import { StyledButtonContainer, StyledButtonGroup } from '../styles/styled-components';

interface BreakoutRoomRowProps {
    roomName: string;
}

const LeaveBreakout: FunctionComponent<BreakoutRoomRowProps> = ({ roomName }) => {
    const { t } = useTranslation('breakout_room');
    const { leaveBreakout } = useContainer(BreakoutRoomOptionsContainer);

    const toolTip = `${t('leave')} ${roomName}`;

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();

        leaveBreakout();
    };

    return (
        <StyledButtonContainer>
            <StyledButtonGroup>
                <Tooltip title={toolTip} placement="left" arrow>
                    <Button color="primary" variant="outlined" onClick={handleClick} size="small">
                        {t('leave')}
                    </Button>
                </Tooltip>
            </StyledButtonGroup>
        </StyledButtonContainer>
    );
};

export default LeaveBreakout;
